import styled from 'styled-components';

export const StatusCountsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 10px 0 20px 0;

  .ui.header {
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }

  .status-icon {
    margin-right: 0.25rem !important;
  }

  span {
    margin-top: -3px;
  }
`;
